/**
 * Created by Vladislav on 20.09.2024.
 */

cleverapps.Tool.flyingAd = ToolFolder.create(() => { 
    const res = {};
    Object.keys(FlyingAd.TYPES).forEach((type) => {
        if (!FlyingAd.DATA[FlyingAd.TYPES[type]].filter({ tool: true })) {
            return;
        }
        res[type] = function () {
            cleverapps.flyingAd.setDelay(0);
            FlyingAd.DEBUG_TYPE = FlyingAd.TYPES[type];
            cleverapps.flyingAd.update();
        };
    });

    res.reset = function () {
        delete FlyingAd.DEBUG_TYPE;
        cleverapps.flyingAd.update();
    };

    return res;
});